class RelatedCaseStudy {
  constructor(contentfulNode) {
    this.categories = contentfulNode?.categories;
    this.clientName = contentfulNode?.clientName;
    this.heroImageData = {
      fluid: contentfulNode?.heroImage?.gatsbyImageData,
      title: contentfulNode?.title
    };
    this.slug = contentfulNode?.slug;
    this.snippet = contentfulNode?.snippet?.snippet ?? 'Case Study Snippet';
    this.title = contentfulNode?.title ?? 'Case Study Title';
  }
}

export default RelatedCaseStudy;
